<ion-row [ngClass]="'align-' + data.alignment">
  <ion-col (click)="linkToDetail(data)">
    <div class="feature-wrapper">
      <div class="img-wrapper">
        <app-img-format
          *ngIf="data.featuredImage"
          [src]="data.featuredImage"
          [alt]="data.title"
          [aspectRatio]="'16:9'"
          [disableLazyLoad]="true"></app-img-format>

        <!-- SPONSOR -->
        <app-sponsor-overlay
          *ngIf="data?.advertise"
          [sponsor]="data?.advertise"></app-sponsor-overlay>
      </div>
      <ion-card>
        <ion-card-header>
          <ion-card-subtitle>
            <ng-container *ngIf="
              data?.typeSettings?.centerOffer &&
              data?.typeSettings?.offerLocation
            ">
              {{ data.typeSettings.offerLocation | titlecase }} &nbsp;|&nbsp;
            </ng-container>
            <ng-container *ngIf="
                showType && data?.postType && !data?.typeSettings?.centerOffer
              ">
              {{ data?.postType | titlecase }} &nbsp;|&nbsp;
            </ng-container>
            <ng-container *ngIf="!hideCategory && !data?.typeSettings?.centerOffer">
              {{ data.category?.title | uppercase }} &nbsp;|&nbsp;
            </ng-container>
            <ng-container *ngIf="!startDate && data?.postType !== 'competition'">
              {{ updatedAt | date : 'd MMM y' | uppercase }}
            </ng-container>
            <ng-container *ngIf="startDate && !sameDay && data?.postType !== 'competition'">
              {{ startDate | date : 'd MMM' | uppercase }} -
              {{ endDate | date : 'd MMM y' | uppercase }}
            </ng-container>
            <ng-container *ngIf="sameDay && data?.postType !== 'competition'">
              {{ startDate | date : 'd MMM y' | uppercase }}
            </ng-container>
            <ng-container *ngIf="endDate && data?.postType === 'competition'">
              ENDS {{ endDate | date : 'd MMM y' | uppercase }}
            </ng-container>
          </ion-card-subtitle>
          <ion-card-title>{{ data.title }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <span *ngIf="data?.typeSettings?.excerpt; else defaultExcerpt">
            {{
              data?.typeSettings?.isBlog
                ? data.excerpt
                : data.typeSettings.excerpt
            }}
          </span>
          <ng-template #defaultExcerpt>
            {{ data.excerpt }}
          </ng-template>
        </ion-card-content>
        <div class="button-wrapper ion-hide-sm-down">
          <app-button
            type="text"
            (click)="linkToDetail(data)"
            [icon]="{ name: 'arrow-right', position: 'right' }">
            Read more
          </app-button>
        </div>
      </ion-card>
    </div>
  </ion-col>
</ion-row>
